import React, { Component } from 'react';
import Backdrop from './Backdrop';
import ModalContainer from './ModalContainer';

class BootstrapModalOutlet extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modalComponentProps: {}      
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
        modalComponentProps: {
          modalPhotoUrl: nextProps.modalPhotoUrl,
          modalPhotoTitle: nextProps.modalPhotoTitle,
          modalComponent: nextProps.modalComponent
        }
    });
  }

  render() {
    return (      
        <div>
            <Backdrop showBackdrop={this.props.showBackdrop}></Backdrop>
            <ModalContainer modalComponentProps={this.state.modalComponentProps} showModal={this.props.showModal}></ModalContainer>
        </div>
    );
  }
}

export default BootstrapModalOutlet;



/** WEBPACK FOOTER **
 ** ./src/modal/BootstrapModalOutlet.js
 **/